"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.filterScope = filterScope;
exports.sortScope = sortScope;
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

/**
 * sorts a list of scopes
 * @param {string} scope
 * @returns {string}
 */
function sortScope(scope) {
  if (!scope) {
    return '';
  }
  return scope.split(' ').sort().join(' ');
}

/**
 * sorts a list of scopes and filters the specified scope
 * @param {string} toFilter
 * @param {string} scope
 * @returns {string}
 */
function filterScope(toFilter, scope) {
  if (!scope) {
    return '';
  }
  return scope.split(' ').filter(function (item) {
    return item !== toFilter;
  }).sort().join(' ');
}
//# sourceMappingURL=scope.js.map
